<template lang="pug">
  .component.component-backoffice-client-custom-fields-configuration
    .row(v-for="elem, index in value")
      DeleteConf(@click="value.splice(index, 1)")
      .column(v-for="val, inx in elem")
        input(v-if="inx !== 'validation'  && inx !== 'default'", type="text", :placeholder="inx", v-model="value[index][inx]")
        ValidationConfig(v-else-if=" inx !== 'default'", v-model="value[index]", validation-key="validation")
</template>

<script>
  import ValidationConfig from './ValidationConfig'
  import DeleteConf from './DeleteConf'

  export default {
    name: 'ClientCustomFieldsConfiguration',
    components: {DeleteConf, ValidationConfig},
    props: ['value']
  }
</script>

<style lang="sass">
  .component-backoffice-client-custom-fields-configuration
    margin-bottom: 1em

    .row
      margin-bottom: 1em
      border-bottom: 1px solid #dedede

</style>



// WEBPACK FOOTER //
// ClientCustomFieldsConfiguration.vue?455d4382